const getDefaultState = () => {
  return {
    blocks: [],
  }
};

export default {
  state: getDefaultState(),
  mutations: {
    blockAdd(state, block) {
      let index = state.blocks.findIndex(item => item.embedId === block.embedId );
      if (index >= 0) {
        state.blocks.splice(index, 1);
      }
      block.elapsedTime = block.totalTime;
      state.blocks.push(block);
    },
    blockDelete(state, blockEmbedId) {
      let index = state.blocks.findIndex(item => item.embedId === blockEmbedId );
      if (index >= 0) {
        state.blocks.splice(index, 1);
      }
    },
    blockIncrement(state, blockId) {
      let index = state.blocks.findIndex(item => item.id === blockId );
      const now = new Date().getTime();
      let activeSince = state.blocks[index].activeSince;
      if (activeSince === 0) activeSince = now;
      state.blocks[index].elapsedTime = state.blocks[index].totalTime + (now - activeSince);
    },
    elementStart(state, data) {
      state.blocks[data.index].elements.push(data.element);
      state.blocks[data.index].activeSince = data.element.start;
    },
    elementEnd(state, data) {
      state.blocks[data.index].elements[data.last].end = data.end;
      const total = state.blocks[data.index].elements[data.last].end - state.blocks[data.index].elements[data.last].start;
      state.blocks[data.index].totalTime += total;
      state.blocks[data.index].activeSince = 0;
    },
    elementUpdate(state, data) {
      state.blocks[data.index].elements.push(data.element);
    },
    elementRemove(state, data) {
      state.blocks[data.index].elements.splice(state.blocks[data.index].elements.length - 1, 1);
    },
    elementsReset(state, data) {
      state.blocks[data.index].elements.splice(0, state.blocks[data.index].elements.length);
      state.blocks[data.index].elapsedTime = 0;
      state.blocks[data.index].totalTime = 0;
    },
    countdownIncrement(state, blockId) {
      let index = state.blocks.findIndex(item => item.id === blockId );
      const now = new Date().getTime();
      let activeCountdownSince = state.blocks[index].activeCountdownSince;
      if (activeCountdownSince === 0) activeCountdownSince = now;
      state.blocks[index].elapsedTime = now - activeCountdownSince;
    },
    countdownStart(state, data) {
      state.blocks[data.index].activeCountdownSince = data.start;
    },
    countdownEnd(state, data) {
      state.blocks[data.index].activeCountdownSince = 0;
      state.blocks[data.index].elapsedTime = 0;
    },
    blockNotificationUpdate(state, block) {
      let index = state.blocks.findIndex(item => item.id === block.id );
      state.blocks[index].notificationSent = block.status;
    },
  }
}
